var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.50024C7.31295 3.50024 3.49995 7.31324 3.49995 12.0002C3.49995 16.6872 7.31295 20.5002 12 20.5002C16.687 20.5002 20.5 16.6872 20.5 12.0002C20.5 7.31324 16.687 3.50024 12 3.50024ZM12 22.0002C6.486 22.0002 2 17.5142 2 12.0002C2 6.48624 6.486 2.00024 12 2.00024C17.514 2.00024 22 6.48624 22 12.0002C22 17.5142 17.514 22.0002 12 22.0002Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9941 13.3733C11.5801 13.3733 11.2441 13.0373 11.2441 12.6233V8.20435C11.2441 7.79035 11.5801 7.45435 11.9941 7.45435C12.4081 7.45435 12.7441 7.79035 12.7441 8.20435V12.6233C12.7441 13.0373 12.4081 13.3733 11.9941 13.3733Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.005 16.7961C11.452 16.7961 11 16.3491 11 15.7961C11 15.2431 11.443 14.7961 11.995 14.7961H12.005C12.558 14.7961 13.005 15.2431 13.005 15.7961C13.005 16.3491 12.558 16.7961 12.005 16.7961Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.db8223e74101b1f9d681a3b1e40105b3.svg";
export { ForwardRef as ReactComponent };